module.exports = require("core-js-pure/stable/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-prototype-of.js
// module id = 220
// module chunks = 0 1